import React, { PropsWithChildren } from 'react';
import { connect } from 'react-redux';
import { selectPhotoById } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { PhotoPrintDesktopErrorOverlay } from '../_desktop/photo-print/PhotoPrintDesktopErrorOverlay';
import { PhotoPrintMobileErrorOverlay } from '../_mobile/photo-print/PhotoPrintMobileErrorOverlay';
import { PhotoPrintSpinner } from './PhotoPrintSpinner';
import styles from './PhotoPrintErrorWrapper.module.scss';

const _PhotoPrintErrorWrapper = ({ photo, children, isMobile }: Props) => {
    if (photo.status === 'error') {
        return (
            <div className={styles.container}>

                {photo.processed ? children : <PhotoPrintSpinner />}

                {isMobile ? (
                    <PhotoPrintMobileErrorOverlay photoId={photo.id} />
                ) : (
                    <PhotoPrintDesktopErrorOverlay photoId={photo.id} />
                )}
            </div>
        );
    } else {
        return (<>{children}</>);
    }
};

type OwnProps = PropsWithChildren<{
    id: string;
    isMobile: boolean;
}>;

type Props = OwnProps & {
    photo: PhotoPrintsJson.Photo;
};

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => ({
    photo: selectPhotoById(state, ownProps.id)!
});

export const PhotoPrintErrorWrapper = connect(mapStateToProps)(_PhotoPrintErrorWrapper);